import { Eye, EyeOff } from "lucide-react";

export const SA_BANKS = [
  { name: "Absa Bank", branchCode: "632005" },
  { name: "African Bank", branchCode: "430000" },
  { name: "Bidvest Bank", branchCode: "462005" },
  { name: "Capitec Bank", branchCode: "470010" },
  { name: "Discovery Bank", branchCode: "679000" },
  { name: "First National Bank (FNB)", branchCode: "250655" },
  { name: "Grindrod Bank", branchCode: "584000" },
  { name: "Investec Bank", branchCode: "580105" },
  { name: "Nedbank", branchCode: "198765" },
  { name: "Sasfin Bank", branchCode: "683000" },
  { name: "Standard Bank", branchCode: "051001" },
  { name: "TymeBank", branchCode: "678910" },
  { name: "Bank Zero", branchCode: "888000" },
  { name: "Finbond Mutual Bank", branchCode: "589000" },
  { name: "GBS Mutual Bank", branchCode: "586001" },
  { name: "Ubank", branchCode: "431010" },
];

// View mode — shows masked account with toggle
export const BankingDetailsView = ({
  bankingDetail,
  maskedBankAccount,
  showAccount,
  onToggleAccount,
}) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div>
      <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
        Bank
      </label>
      <p className="text-sm text-text-primary py-2">
        {bankingDetail?.bankName || <span className="text-text-hint">—</span>}
      </p>
    </div>
    <div>
      <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
        Branch Code
      </label>
      <p className="text-sm text-text-primary py-2">
        {bankingDetail?.branchCode || <span className="text-text-hint">—</span>}
      </p>
    </div>
    <div className="sm:col-span-2">
      <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
        Account Number
      </label>
      <div className="flex items-center gap-2 py-2">
        <p className="text-sm text-text-primary">
          {showAccount
            ? bankingDetail?.accountNumber
            : (maskedBankAccount ?? "—")}
        </p>
        {bankingDetail?.accountNumber && (
          <button
            onClick={onToggleAccount}
            className="text-text-hint hover:text-text-muted transition"
          >
            {showAccount ? <EyeOff size={13} /> : <Eye size={13} />}
          </button>
        )}
      </div>
    </div>
    <p className="sm:col-span-2 text-xs text-text-hint">
      Banking details are used for payout processing. Click Edit to update.
    </p>
  </div>
);

// Edit mode — bank dropdown, auto branch code, account number
const BankingDetailsForm = ({ fields, onChange }) => {
  const handleBankChange = (bankName) => {
    const selected = SA_BANKS.find((b) => b.name === bankName);
    onChange("bankAccount_BankName", bankName);
    onChange("bankAccount_BranchCode", selected?.branchCode ?? "");
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* Bank dropdown */}
      <div>
        <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
          Bank
        </label>
        <select
          value={fields.bankAccount_BankName ?? ""}
          onChange={(e) => handleBankChange(e.target.value)}
          className="w-full bg-bg-base border border-border rounded-xl px-4 py-2.5 text-sm text-text-primary focus:outline-none focus:border-primary transition appearance-none"
        >
          <option value="">Select a bank</option>
          {SA_BANKS.map((bank) => (
            <option key={bank.name} value={bank.name}>
              {bank.name}
            </option>
          ))}
        </select>
      </div>

      {/* Branch code — auto filled, read only */}
      <div>
        <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
          Branch Code
        </label>
        <input
          type="text"
          value={fields.bankAccount_BranchCode ?? ""}
          readOnly
          className="w-full bg-bg-elevated border border-border rounded-xl px-4 py-2.5 text-sm text-text-muted cursor-not-allowed"
        />
      </div>

      {/* Account number */}
      <div className="sm:col-span-2">
        <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
          Account Number
        </label>
        <input
          type="text"
          value={fields.bankAccount_AccountNumber ?? ""}
          onChange={(e) =>
            onChange("bankAccount_AccountNumber", e.target.value)
          }
          placeholder="Account number"
          className="w-full bg-bg-base border border-border rounded-xl px-4 py-2.5 text-sm text-text-primary placeholder-text-hint focus:outline-none focus:border-primary transition"
        />
      </div>
    </div>
  );
};

export default BankingDetailsForm;
